import React, { FC } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import './training-draft-form.css';

export interface TrainingDraftStepperStep {
  label: string;
}

export interface TrainingDraftStepperProps {
  steps: TrainingDraftStepperStep[];
  activeStep: number;
  completedSteps?: Set<number> | number[];
  onStepChange: (index: number) => void;
}

const TrainingDraftStepper: FC<TrainingDraftStepperProps> = ({ steps, activeStep, completedSteps, onStepChange }) => {
  const completed = completedSteps instanceof Set ? completedSteps : new Set(completedSteps || []);

  return (
    <div className="training-draft-stepper">
      {steps.map((step, index) => {
        const isActive = activeStep === index;
        const isCompleted = completed.has(index) && !isActive;

        return (
          <button
            key={step.label}
            type="button"
            className={`training-draft-stepper__pill${isActive ? ' is-active' : ''}${
              isCompleted ? ' is-completed' : ''
            }`}
            onClick={() => onStepChange(index)}
          >
            {isCompleted ? (
              <CheckCircleIcon className="training-draft-stepper__check" />
            ) : (
              <span className="training-draft-stepper__num">{index + 1}</span>
            )}
            {step.label}
          </button>
        );
      })}
    </div>
  );
};

export default TrainingDraftStepper;
